import { makeStyles } from '@material-ui/core/styles';
import { XMEI_SECONDARY_COLOR } from 'src/consts/common';

export const useStyles = makeStyles((theme) => ({
  ConfirmButton: {
    margin: theme.spacing(2, 0, 2),
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
    '&:hover': {
      backgroundColor: XMEI_SECONDARY_COLOR,
    },
  },
}));
